import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "../../lib/brand";
import { Check, Ban, Sofa, Refrigerator, Trash2, TreePine, Package, Building2 } from "lucide-react";

const TAKE = [
  { icon: Sofa, label: "Furniture — couches, mattresses, tables" },
  { icon: Refrigerator, label: "Appliances — fridges, stoves, washers" },
  { icon: Package, label: "Household clutter & garage cleanouts" },
  { icon: Trash2, label: "Yard junk, old fencing, small sheds" },
  { icon: TreePine, label: "Renovation debris" },
  { icon: Building2, label: "Office & estate cleanouts" },
];

const DONT = [
  "Dirt, soil & fill",
  "Concrete & heavy rubble",
  "Big demolition jobs",
  "Hazardous / toxic waste",
];

export const Services = () => (
  <section id="services" className="relative bg-[#0a0a0a] section-divider grain overflow-hidden">
    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-16 lg:py-24">
      <div className="mb-12">
        <span className="text-xs uppercase tracking-[0.2em] text-[#7CB518]">// What We Do</span>
        <h2 className="font-display uppercase text-4xl md:text-6xl mt-2 leading-none">
          Stuff We <span className="text-[#7CB518]">Take</span>
        </h2>
      </div>

      <div className="grid lg:grid-cols-3 gap-0 border-2 border-[#2d2d2d]">
        <div className="lg:col-span-2 grid sm:grid-cols-2">
          {TAKE.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="border-b-2 border-r-0 sm:border-r-2 border-[#2d2d2d] p-6 flex items-start gap-4 hover:bg-[#111] transition-colors"
            >
              <span className="shrink-0 w-11 h-11 grid place-items-center bg-[#7CB518] text-black">
                <item.icon size={22} />
              </span>
              <div>
                <Check className="text-[#7CB518] mb-1" size={16} />
                <p className="text-sm text-white/85 leading-snug">{item.label}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="relative min-h-[280px] bg-cover bg-center" style={{ backgroundImage: `url(${IMAGES.garage})` }}>
          <div className="absolute inset-0 bg-black/50" />
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <p className="font-display uppercase text-2xl leading-none">
              If it fits in the<br /><span className="text-[#7CB518]">truck, it's gone.</span>
            </p>
          </div>
        </div>
      </div>

      {/* Don't take */}
      <div className="mt-10 border-2 border-[#7CB518] bg-[#7CB518]/5">
        <div className="caution-tape h-3" />
        <div className="p-6 sm:p-8">
          <div className="flex items-center gap-3 mb-5">
            <Ban className="text-[#7CB518]" size={26} />
            <h3 className="font-display uppercase text-2xl md:text-4xl">What We Don't Touch</h3>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {DONT.map((d, i) => (
              <div key={i} data-testid={`dont-take-${i}`} className="flex items-center gap-3 border-2 border-[#2d2d2d] p-4">
                <Ban className="text-red-500 shrink-0" size={18} />
                <span className="text-sm uppercase tracking-wide text-white/90">{d}</span>
              </div>
            ))}
          </div>
          <p className="mt-5 text-xs text-white/50 uppercase tracking-[0.15em]">
            Not sure about your load? Give us a shout before you book.
          </p>
        </div>
      </div>
    </div>
  </section>
);
